export { Word } from "./Word";
